import React from "react";
import { useSearchParams } from "react-router-dom";
import GetCharacters from "../utils/GetCharacters";

const useCharacterMode = () => {
  const [searchParams] = useSearchParams();
  const [characters, setCharacters] = React.useState(null);
  const characterName = searchParams.get("characterName");

  React.useEffect(() => {
    if (characterName) {
      GetCharacters()
        .then((characters) => {
          const v = characters.find((ch) => ch.name === characterName);

          setCharacters(
            v ? { ...v, hidden_subcategories: JSON.parse(v.hidden_subcategories) } : null
          );
        })
        .catch((e) => console.error(e));
    }
  }, []);

  return { characters, characterName };
};

export default useCharacterMode;
